import React from "react";
import { IoLogoInstagram } from "react-icons/io5";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/kontakt/bg_kontakt.png";

import Image from "../../images/kontakt/kontakt.jpg"

import { FaCalendarAlt, FaPhoneAlt } from "react-icons/fa";
import { FiRefreshCw, FiMail } from "react-icons/fi";
import { GrDocumentText } from "react-icons/gr";


const cards = [
  {
    title: "Termin buchen",
    subtitle: "Terminvereinbarung",
    icon: <FaCalendarAlt />,
    link: "/homepage/#/termine"
  },
  {
    title: "Rezept bestellen",
    subtitle: "Für bekannte Dauermedikation",
    icon: <GrDocumentText />,
    link: "/homepage/#/kontakt/rezeptbestellung"
  },
  {
    title: "Kontaktformular",
    subtitle: "Für allgemeine organisatorische Anliegen",
    icon: <FiMail />,
    link: "/homepage/#/kontakt/terminanfrage"
  }
];

const AppointmentGrid = () => {
  return (
    <div className="appointment-grid">
      {cards.map((card, index) => (
        <button key={index} className="appointment-card" onClick={() => window.location.href = card.link}>
          <div className="card-left">
            <div className="icon-wrapper">{card.icon}</div>

            <div className="card-content">
              <h3>{card.title}</h3>
              <p>{card.subtitle}</p>
            </div>
          </div>

          <span className="arrow">›</span>
        </button>
      ))}
    </div>
  );
}

const Kontakt = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    

                    <h1> Kontakt </h1>
                    <p className="page-text">
                    Für Termine, Rezepte, Rückrufe und organisatorische Anliegen nutzen Sie bitte bevorzugt unsere Online-Services.
                    Telefonisch sind Termine derzeit nicht schneller verfügbar als online.
                    </p>
                    <AppointmentGrid />
                    {/*<img src={Image} style={{float: "right", margin:"15px"}}/> */}



                    
                    <p className="page-text">
                        Sollten Sie einen Ordinationstermin benötigen, reservieren Sie diesen bitte unter <a href="/homepage/#/termine">http://www.herzdoktor.net/#/termine </a> , oder per Telefon unter +43 1 892 17 17.
                        <br /><br />
                        Bitte beachten Sie, dass Termine ausschießlich über die Onlinereservierung, oder per Telefon vergeben werden. Eine Terminvergabe per Email ist nicht möglich.
                        <br /><br />
                        Wir haben für die Kontaktaufnahme für Sie zwei Formulare vorbereitet: für allgemeine Anfragen, wie zB: <a href="/homepage/#/kontakt/terminanfrage">Terminanfragen</a>, Rückrufe, usw für die <a href="/homepage/#/kontakt/rezeptbestellung">Rezeptbestellung</a>
                    </p>

                    <div className="contact-details">
                    <table>
                        <tr>
                            <td><strong>PLZ / Ort:</strong></td>
                            <td>1150 Wien</td>
                        </tr>
                        <tr>
                            <td><strong>Straße:</strong></td>
                            <td>Kranzgasse 22 / Hoftrakt</td>
                        </tr>
                        <tr>
                            <td><strong>Tel.:</strong></td>
                            <td>+43 1 892 17 17</td>
                        </tr>
                        <tr>
                            <td><strong>Fax:</strong></td>
                            <td>+43 720 72 00 111</td>
                        </tr>
                        <tr>
                            <td><strong>Kassen:</strong></td>
                            <td>alle Kassen</td>
                        </tr>
                        <tr>
                            <td><strong>Ordinationszeiten:</strong></td>
                            <td>
                                Mo 9–13 und 15–19<br/>
                                Di 8–13<br/>
                                Mi 9–14<br/>
                                Do 8–13 und 14–16<br/>
                                und nach Vereinbarung per <a href="/homepage/#/termine">Internet</a> oder Telefon
                            </td>
                        </tr>
                    </table>

                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2659.810271611998!2d16.330717476054012!3d48.19100694744054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x476da9ad2bf34193%3A0x80ceab65b321c918!2sDr.%20Claudia%20Sebald!5e0!3m2!1sen!2sat!4v1780662522073!5m2!1sen!2sat"
                        width="600"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        className="contact-map"
                    />
                    
                    </div>

                    

                    <br />
                    <div id="instgram-link-container"> 
                        <IoLogoInstagram id="insta-logo"/> <a href="https://www.instagram.com/herzdoktor_und_kollegium/"> Instagram </a>
                    </div>

                    {/*
                    <p className="grey-text">
                        <h3>Telefonische Auskünfte </h3>
                        Es gibt gibt prinzipiell KEINE telefonischen Befundbesprechungen. Wir bitten diesbezüglich um Verständnis. Jeder/e Patient/in soll ungestört (von evtl. Telefonaten) mit seiner Ärztin sprechen können!
                        <h3> Medizinische Anfragen per Email </h3>
                        Wir möchten Sie darüber informieren, dass aufgrund von Datenschutzbestimmungen und begrenzten Zeitressourcen unser Hauptfokus auf der Bearbeitung von Rezepten und Terminanfragen liegt. <b> Wir geben keine Antworten auf medizinische Anfragen per Mail.</b>
                        <br /> <br />
                        Wir verstehen, wie wichtig es ist, alle Fragen und Anliegen rund um Ihre Gesundheit zu klären, und bedauern die Unannehmlichkeiten, die dies verursachen kann. Bitte haben Sie Verständnis dafür, dass dies notwendig ist, um sicherzustellen, dass wir Ihre Anliegen so effizient und verantwortungsbewusst wie möglich bearbeiten können. 
                        <br /> <br />
                        Für <b>konkrete medizinische Fragen oder Anliegen empfehlen wir Ihnen, einen persönlichen Termin zu vereinbaren </b>, damit wir Ihre Situation genauer besprechen können. Wir sind bestrebt, Ihnen weiterhin die bestmögliche Versorgung zukommen zu lassen.
                        <br /> <br />
                        Wir danken Ihnen für Ihr Verständnis und stehen Ihnen gerne zur Verfügung, um Ihre <b>Terminanfragen und Rezepte zu bearbeiten.</b>
                    </p>
                    */}

                    <h3>Wichtige Hinweise </h3>

                    <div class="info-item">
                    <span class="plus">+</span>
                        <p>
                            Aus rechtlichen Gründen bitte keine medizinischen Anfragen per E-Mail oder Kontaktformular.
                        </p>
                    </div>

                    <div class="info-item">
                        <span class="plus">+</span>
                        <p>
                            Bitte buchen Sie Termine bevorzugt online. Eine Terminvergabe per E-Mail ist nicht möglich.
                        </p>
                    </div>

                    <div class="info-item">
                        <span class="plus">+</span>
                        <p>
                            Keine telefonischen Befundbesprechungen. Für medizinische Fragen oder
                            Befundbesprechungen vereinbaren Sie bitte einen Termin in unserer Ordination.
                        </p>
                    </div>
                    
                </div>

            </section>
            <Footer />
        </main>
    )
}

export default Kontakt;